import React, { useState, useEffect } from 'react';
import { Add_country, List_country } from "../../../Utils/Api";
import { toast } from 'react-toastify';

const Countries = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    phoneCode: '',
    currency: '',
    status: '0'
  });
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch countries on component mount
  useEffect(() => {
    fetchCountries();
  }, []);

  // Fetch all countries
  const fetchCountries = async () => {
    setLoading(true);
    try {
      const response = await List_country();
      if (response && response.data?.data) {
        setCountries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
      toast.error('Failed to fetch countries');
    } finally {
      setLoading(false);
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission (Add/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      toast.error('Please enter country name');
      return;
    }
    if (!formData.code.trim()) {
      toast.error('Please enter country code');
      return;
    }
    if (!formData.phoneCode.trim()) {
      toast.error('Please enter phone code');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        status: parseInt(formData.status)
      };

      if (editingId) {
        // Update existing country
        // await Update_country(editingId, payload);
        toast.success('Country updated successfully');
      } else {
        // Add new country
        await Add_country(payload);
        toast.success('Country added successfully');
      }

      // Reset form and refresh list
      resetForm();
      setShowModal(false);
      fetchCountries();
    } catch (error) {
      console.error('Error saving country:', error);
      toast.error('Failed to save country');
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      name: '',
      code: '',
      phoneCode: '',
      currency: '',
      status: '0'
    });
    setEditingId(null);
  };

  // Handle edit
  const handleEdit = (country) => {
    setFormData({
      name: country.name || '',
      code: country.code || '',
      phoneCode: country.phoneCode || '',
      currency: country.currency || '',
      status: country.status?.toString() || '0'
    });
    setEditingId(country._id || country.id);
    setShowModal(true);
  };

  // Handle delete
  const handleDelete = async () => {
    if (!deleteId) return;

    setLoading(true);
    try {
      //   await Delete_country(deleteId);
      toast.success('Country deleted successfully');
      setDeleteId(null);
      fetchCountries();
    } catch (error) {
      console.error('Error deleting country:', error);
      toast.error('Failed to delete country');
    } finally {
      setLoading(false);
    }
  };

  // Open add modal
  const handleAdd = () => {
    resetForm();
    setShowModal(true);
  };

  return (
    <div className="main-content">
      <div className="row my-4 mx-1">
        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
          <h1 className="page-title fw-semibold fs-18 mb-0 mt-2">Countries</h1>
          <div className="ms-md-1 ms-0 ">
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Location</a></li>
                <li className="breadcrumb-item active" aria-current="page">Countries</li>
              </ol>
            </nav>
          </div>
        </div>


        {/* Main Content Card */}
        <div className="card custom-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">Countries List</h6>
            <button
              className="btn btn-primary btn-sm"
              onClick={handleAdd}
            >
              <i className="ri-add-line me-1"></i> Add Country
            </button>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-nowrap">
                <thead className="table-primary">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Country Name</th>
                    <th scope="col">Code</th>
                    <th scope="col">Phone Code</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created Date</th>
                    <th scope="col">Actions</th>

                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  )}

                  {!loading && countries.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        No countries found
                      </td>
                    </tr>
                  )}

                  {!loading && countries.map((country, index) => (
                    <tr key={country._id || country.id}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="flag-icon flag-icon-{country.code.toLowerCase()} me-2"></span>
                          {country.name}
                        </div>
                      </td>
                      <td><span className="badge bg-light text-dark">{country.code}</span></td>
                      <td><span className="text-muted">{country.phoneCode}</span></td>
                      <td>
                        <span className={`badge ${country.status === 0 ? 'bg-success-transparent' : 'bg-danger-transparent'}`}>
                          {country.status === 0 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>{new Date(country.createdAt || Date.now()).toLocaleDateString()}</td>
                      <td>
                        <div className="hstack gap-2 fs-15">
                          <button
                            onClick={() => handleEdit(country)}
                            className="btn btn-icon btn-sm btn-info-transparent rounded-pill"
                            title="Edit"
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                          <button
                            onClick={() => setDeleteId(country._id || country.id)}
                            className="btn btn-icon btn-sm btn-danger-transparent rounded-pill"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteModal"
                            title="Delete"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        {showModal && (
          <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {editingId ? 'Edit Country' : 'Add New Country'}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="row">
                      {/* Country Name */}
                      <div className="col-12 mb-3">
                        <label htmlFor="name" className="form-label">
                          Country Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="e.g., India"
                          required
                        />
                      </div>

                      {/* Country Code */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="code" className="form-label">
                          Country Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="code"
                          name="code"
                          value={formData.code}
                          onChange={handleInputChange}
                          placeholder="e.g., IN"
                          maxLength="2"
                          style={{ textTransform: 'uppercase' }}
                          required
                        />
                        <small className="text-muted">2-letter ISO code</small>
                      </div>

                      {/* Phone Code */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phoneCode" className="form-label">
                          Phone Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="phoneCode"
                          name="phoneCode"
                          value={formData.phoneCode}
                          onChange={handleInputChange}
                          placeholder="e.g., +91"
                          required
                        />
                      </div>

                      {/* Status */}
                      <div className="col-12 mb-3">
                        <label htmlFor="name" className="form-label">
                          Currency <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="currency"
                          name="currency"
                          value={formData.currency}
                          onChange={handleInputChange}
                          placeholder="e.g., currency"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          {editingId ? 'Updating...' : 'Adding...'}
                        </>
                      ) : (
                        editingId ? 'Update' : 'Add'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        <div className="modal fade" id="deleteModal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => setDeleteId(null)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this country?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => setDeleteId(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                  disabled={loading}
                >
                  {loading ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countries;
